import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Row,
	Col,
	Card,
	CardBody,
	CardText,
	Button,
	ButtonGroup
} from 'reactstrap';

import { Tbl, TblHead, TblBody } from '../../components/Tbl';
import FilterPanel from './Filters';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import { CardHeaderWithToolbars, Title } from '../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars';
import DateToHuman from '../../components/DateToHuman';
import CheckReadOnly from '../../components/CheckReadOnly';

import { DEFAULT_PER_PAGE } from '../../constants/settings';
import { getSubcategoriesList } from '../../actions/subcategoriesAction';
import { getOptionList as getCategoryOptionList } from '../../actions/categoriesAction';
import { buildSubcategoryListParams, getSubcategoryListItems } from '../../helpers/subcategories';
import privateView from '../../components/hocs/privateView';
import Analytics from '../../services/Analytics';

const dataHeader = [
	'No.', 'Name', 'Category', 'Active', 'Created', 'Updated', 'Action'
];

const defaultParams = {
	sort_by: 'updated_at_desc',
	per_page: DEFAULT_PER_PAGE
};

const getCategoryName = (item) => {
	if (item.category && item.category.name) {
		return item.category.name;
	}
	if (item.category_name) {
		return item.category_name;
	}
	return '-';
};

class SubcategoriesIndex extends Component {
	constructor() {
		super();
		this.state = {
			_params: {
				...defaultParams
			},
			_filterOpen: false
		};
		this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
		this._handleParamsChange = this._handleParamsChange.bind(this);
		this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
		this._handleRefresh = this._handleRefresh.bind(this);
		this._handleResetFilter = this._handleResetFilter.bind(this);
		this._handleRowClick = this._handleRowClick.bind(this);
		this._handleCursorPage = this._handleCursorPage.bind(this);
	}

	componentDidMount() {
		const { email } = this.props.injectedProps;
		this._getList(this.state._params);
		this.props.getCategoryOptions();
		Analytics.recordPageView('subcategory_list', email, {
			url: window.location.href,
			location: this.props.location,
			match: this.props.match
		});
	}

	_toggleFilterPanel() {
		this.setState({ _filterOpen: !this.state._filterOpen });
	}

	_handleToggleFilterPanel(e) {
		e.preventDefault();
		this._toggleFilterPanel();
	}

	_handleRowClick(id) {
		this.props.history.push(`/subcategories/${id}`);
	}

	_getListItems() {
		return getSubcategoryListItems(this.props.masterSubcategories.list);
	}

	_onRenderRowItem() {
		const items = this._getListItems();
		if (this.props.masterSubcategories.list.status_code === 200 && items.length > 0) {
			return items.map((item, index) =>
				(
					<tr
						key={item.id}
						style={{ cursor: 'pointer' }}
						onClick={() => this._handleRowClick(item.id)}
					>
						<th scope="row">{index + 1}</th>
						<td>{item.name}</td>
						<td>{getCategoryName(item)}</td>
						<td><CheckReadOnly check={item.active} /></td>
						<td><DateToHuman value={item.created_at} id={`tooltip_createdAt_${item.id}`} /></td>
						<td><DateToHuman value={item.updated_at} id={`tooltip_updatedAt_${item.id}`} /></td>
						<td>
							<Link
								to={`/subcategories/${item.id}`}
								className="btn btn-link"
								onClick={(e) => e.stopPropagation()}
							>
								Details
							</Link>
						</td>
					</tr>
				)
			);
		}
		return null;
	}

	_onRenderPagination() {
		const { next_cursor, prev_cursor, status_code } = this.props.masterSubcategories.list;
		const items = this._getListItems();
		const hasData = status_code === 200 && items.length > 0;

		if (!hasData && !next_cursor && !prev_cursor) {
			return null;
		}

		return (
			<div className="d-flex justify-content-between align-items-center mt-3">
				<span>{items.length > 0 ? `Showing ${items.length} subcategories` : 'No subcategories on this page'}</span>
				<ButtonGroup>
					<Button
						size="sm"
						color="secondary"
						disabled={!prev_cursor || this.props.masterSubcategories.isFetch}
						onClick={() => this._handleCursorPage(prev_cursor)}
					>
						Previous
					</Button>
					<Button
						size="sm"
						color="secondary"
						disabled={!next_cursor || this.props.masterSubcategories.isFetch}
						onClick={() => this._handleCursorPage(next_cursor)}
					>
						Next
					</Button>
				</ButtonGroup>
			</div>
		);
	}

	_handleCursorPage(cursor) {
		this.props.getList({
			params: {
				...buildSubcategoryListParams(this.state._params),
				cursor,
			}
		});
	}

	_getList(rawParams = {}) {
		this.props.getList({ params: buildSubcategoryListParams(rawParams) });
	}

	_refreshList() {
		this._getList(this.state._params);
	}

	_handleParamsChange(e) {
		this.setState({
			_params: {
				...this.state._params,
				[e.target.name]: e.target.value
			}
		});
	}

	_handleParamsChangeAndSubmit(e) {
		const { page, ...rest } = this.state._params;
		const _params = {
			...rest,
			[e.target.name]: e.target.value
		};
		this.setState({ _params }, () => {
			this._getList(this.state._params);
		});
	}

	_handleRefresh(e) {
		e.preventDefault();
		this._refreshList();
	}

	_handleResetFilter(e) {
		e.preventDefault();
		const newState = this.state._filterOpen ? { _filterOpen: !this.state._filterOpen } : {};
		this.setState({
			...newState,
			_params: {
				...defaultParams
			}
		}, () => this._getList(this.state._params));
	}

	render() {
		const items = this._getListItems();

		return (
			<div className="animated fadeIn">
				<Row>
					<Col xs={12}>
						<Card>
							<CardHeaderWithToolbars>
								<Title>
									<i className="fa fa-align-justify"></i>
									<span>Subcategory List</span>
								</Title>
								<Toolbars
									isOpen={this.state._filterOpen}
									onToggleFilter={this._handleToggleFilterPanel}
									onRefreshList={this._handleRefresh}
									onResetFilter={this._handleResetFilter}
								/>
							</CardHeaderWithToolbars>
							<FilterContainer>
								<FilterPanel
									{...this.state._params}
									categoryOptions={this.props.categoryOptions}
									onHandleChange={this._handleParamsChange}
									onHandleChangeAndSubmit={this._handleParamsChangeAndSubmit}
									onHandleSearch={this._handleRefresh}
									isOpen={this.state._filterOpen}
								/>
							</FilterContainer>
							<CardBody>
								<CardText>
									Manage subcategories for product classification within categories.
								</CardText>
								<div className="table-responsive">
									<Tbl>
										<TblHead
											dataHeader={dataHeader}
										/>
										<TblBody
											isLoad={this.props.masterSubcategories.isFetch}
											hasRow={this.props.masterSubcategories.list.status_code === 200 && items.length > 0}
											columnCount={dataHeader.length}
										>
											{this._onRenderRowItem()}
										</TblBody>
									</Tbl>
								</div>
								{this._onRenderPagination()}
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = ({ masterSubcategories, masterCategories: { options }, auth: { isFetch, roles, isLogged, id, email } }) => {
	return {
		masterSubcategories,
		categoryOptions: options,
		guardData: { isFetch, roles, isLogged, id, email }
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getList: (query) => dispatch(getSubcategoriesList(query)),
		getCategoryOptions: () => dispatch(getCategoryOptionList())
	};
};

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(privateView(SubcategoriesIndex));
